import React from 'react'
import { RefundListItem } from '../../../../../services/api/refunds'
import { Property } from '../../../../../components'
import { displayDatetime } from '../../../../../utils/formatter'

type Props = {
  refund: RefundListItem
}

export const View: React.FunctionComponent<Props> = ({ refund }) => {
  return (
    <>
      <Property label="Идентификатор">{refund.id}</Property>
      <Property label="Сумма возврата">
        {refund.amount} {refund.amountCurrency}
      </Property>
      <Property label="Комментарий">{refund.comment}</Property>
      <Property label="Время возврата">
        {displayDatetime(refund.createdAt)}
      </Property>
    </>
  )
}
